export interface Usuario {
  name: string;
  permissionGroup: string;
  status: string;
  login: string;
  id: string;
}
export class Fundo {
  code: string;
  name: string;
  cnpj: string;
  constructor() {
  }
}

export class UsuarioId {
  id: string;
  constructor() {
  }
}
export class Grupo {
  name: string;
  users: UsuarioId[];
  funds: Fundo[];
  description: string;
  id: string;
  status: number;
  constructor() {
  }
}
